import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  *{ box-sizing:border-box; margin:0; padding:0; }
  html{ scroll-behavior:smooth; }
  body{
    font-family:${({ theme }) => theme.font.body};
    background:${({ theme }) => theme.colors.cream};
    color:${({ theme }) => theme.colors.ink};
    line-height:1.5;
    -webkit-font-smoothing:antialiased;
  }
  a{ color:inherit; text-decoration:none; }
  button{ font-family:inherit; }

  @media (prefers-reduced-motion: reduce){
    *{ animation:none !important; transition:none !important; scroll-behavior:auto !important; }
  }
`;

export default GlobalStyle;
